import { render, staticRenderFns } from "./CustomFilters.vue?vue&type=template&id=805fc25a&scoped=true&lang=pug&"
import script from "./CustomFilters.vue?vue&type=script&lang=js&"
export * from "./CustomFilters.vue?vue&type=script&lang=js&"
import style0 from "./CustomFilters.vue?vue&type=style&index=0&id=805fc25a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805fc25a",
  null
  
)

export default component.exports